export const SHORT_VIDEO_API = {
    DETAIL: `/shortvideo/detail`,
    PLAYLIST: `/playlist/detail`,
    VIEW: `/shortvideo/view`,
    TRACK_INTERACTION: `/shortvideo/track-interaction`,
    NEW_TRACK_INTERACTION: `/short-video/track`,
    SUBMIT_POLL: `/shortvideo/submit-poll`,
    POLL_ANSWER_RESULT: `/shortvideo/poll-answer-result`,
    ANSWER_DEFAULT_QUESTION: `/shortvideo/answer-qna-default-question`,
    ANSWER_FOLLOW_UP_QUESTION: `/shortvideo/answer-qna-followup-question`,
    QNA_ANWSER_RESULT: `/shortvideo/qna-answer-result`,
    TRACK_IOT: '/short-video/track-iot',
    TRACK_SHOPPING: '/short-video/track-shopping',
    LIKE_VIDEO: '/short-video/like',
    UNLIKE_VIDEO: '/short-video/unlike',
}

export const SETTING_API = {
    TRACKING: '/setting/use-new-tracking', // use-new-tracking
}
